export const Focus = {
    inserted(el, binding) {
        setTimeout(() => {
            el.select();
            el.focus();
        }, 0);
    }
};
